import { Action, ActionCreator, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";

import { ApplicationState } from "../store/ApplicationState";
import { configUrl } from "../constants/Config";
import { RequestAuthorizationPayload } from "../models/RequestAuthorization";
import { RequestAuthorization } from "../services/RequestAuthorization";
import { RequestAuthorizationDispatchTypes } from "../constants/RequestAuthorization";

export const requestAuthorization: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    Action<RequestAuthorizationDispatchTypes>
  >
> = (payload: RequestAuthorizationPayload) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: RequestAuthorizationDispatchTypes.REQUEST_AUTHORIZATION_INVOKE,
    });
    const response = await RequestAuthorization(
      configUrl,
      payload
    );
    dispatch({
      response: response.data,
      type: RequestAuthorizationDispatchTypes.REQUEST_AUTHORIZATION_SUCCESS,
    });
  };
};
